import './app.css';



/* is production */
const isProd = process.env.NODE_ENV === 'production';



/* data */
const data = require('./js/data.json');
const countries = data.countries;
const amounts = data.amounts;



/* analytics */
const analytics = require('universal-ga');
analytics.initialize('UA-105301080-3');
analytics.create('UA-88014128-5', 'clientTracker');



/* map */
const L = require('leaflet');

const map = L.map('map', {scrollWheelZoom: false}).setView([countries[0].lat, countries[0].lng], 2);

map.zoomControl.setPosition('bottomleft');

/* set zoom on mobile */
if (document.body.clientWidth < 425) {
    map.setZoom(1);
}

/* enable zoom scroll only after double click */
map.on('dblclick', () => {
    if (map.scrollWheelZoom.enabled()) {
        map.scrollWheelZoom.disable();
    } else {
        map.scrollWheelZoom.enable();
    }
});

/* basic marker icon */
const basicIcon = L.icon({
    iconUrl: 'img/markers/basic.png',
    shadowUrl: 'img/markers/shadow.png',
    iconSize: [32, 32],
    shadowSize: [21, 6],
    iconAnchor: [16, 32],
    shadowAnchor: [0, 3]
});

/* active marker icon */
const activeIcon = L.icon({
    iconUrl: 'img/markers/active.png',
    shadowUrl: 'img/markers/shadow.png',
    iconSize: [32, 32],
    shadowSize: [21, 6],
    iconAnchor: [16, 32],
    shadowAnchor: [0, 3]
});

/* array for modify markers */
const countriesMarkers = [];

/* place marker for each country */
countries.forEach((item) => {
    const marker = new L.marker([item.lat, item.lng], {
        title: item.name,
        alt: item.name,
        icon: basicIcon
    }).on({
        mouseover: (e) => {
            e.target.setIcon(activeIcon);
            const countryLayer = countriesLayers.filter(elem => elem.path === item.path)[0].layer;
            countryLayer.setStyle(activeMapStyle);
        },
        mouseout: (e) => {
            e.target.setIcon(basicIcon);
            const countryLayer = countriesLayers.filter(elem => elem.path === item.path)[0].layer;
            geojson.resetStyle(countryLayer);
        },
        click: (e) => {
            router.navigate(`/${item.path}`);
            e.target.setIcon(activeIcon);
        }
    }).addTo(map);

    countriesMarkers.push({
        short: item.short,
        path: item.path,
        marker: marker
    });
});

/* countries short names array */
const countriesShorts = countries.map(item => item.short);

/* countries paths and layers array for routing */
let countriesLayers = [];

/* orange country style for hover and active */
const activeMapStyle = {
    fillColor: '#fccf52',
    fillOpacity: 1
};

const onEachFeature = (feature, layer) => {
    const countryInOurArray = countriesShorts.includes(layer.feature.id);
    if (countryInOurArray) {

        countriesLayers.push({
            path: countries[countriesShorts.indexOf(layer.feature.id)].path,
            layer: layer
        });

        const marker = countriesMarkers.filter(item => item.short === layer.feature.id)[0].marker;

        layer.on({
            mouseover: (e) => {
                const layer = e.target;
                layer.setStyle(activeMapStyle);
                if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
                    layer.bringToFront();
                }
                marker.setIcon(activeIcon);
            },
            mouseout: (e) => {
                geojson.resetStyle(e.target);
                marker.setIcon(basicIcon);
            },
            click: (e) => {
                router.navigate(`/${countries[countriesShorts.indexOf(e.target.feature.id)].path}`);
            }
        });

    }
}

/* object with countries polygons coordinates */
const world = require('./js/geo.json');

/* place all countries polygons with gray color */
const geojson = L.geoJson(world, {
    style: {
        fillColor: '#9c9c9c',
        weight: 1,
        opacity: 1,
        color: '#fff',
        dashArray: '0',
        fillOpacity: 0.9
    },
    onEachFeature: onEachFeature
}).addTo(map);



/* routing */
const setState = (state) => {
    document.querySelector('body').setAttribute('data-state', state);
};

const setCountry = (countryName) => {
    document.querySelector('body').setAttribute('data-country', countryName);
};

const showCountry = (name) => {

    setState('');

    void document.querySelector('.content__bg').offsetWidth;
    void document.querySelector('.country__name').offsetWidth;
    void document.querySelector('.country__amounts').offsetWidth;
    void document.querySelector('.country__wrapper').offsetWidth;

    setState('country');
    setCountry(name);

    /* send data to analytics */
    analytics.pageview('/' + name);
    analytics.name('clientTracker').pageview('/' + name);

    /* reset markers on all countries */
    countriesMarkers.forEach((item) => {
        item.marker.setIcon(basicIcon);
    });

    /* change marker icon on 'name' country */
    const countryMarker = countriesMarkers.filter(item => item.path === name)[0].marker;
    countryMarker.setIcon(activeIcon);
    countryMarker.on('mouseout', (e) => {
        e.target.setIcon(activeIcon);
        countryLayer.setStyle(activeMapStyle);
    });

    /* reset background on all countries */
    countriesLayers.forEach((item) => {
        geojson.resetStyle(item.layer);
    });

    /* add to background to 'name' country */
    const countryLayer = countriesLayers.filter(item => item.path === name)[0].layer;
    countryLayer.setStyle(activeMapStyle);
    countryLayer.on('mouseout', (e) => {
        e.target.setStyle(activeMapStyle);
        countryMarker.setIcon(activeIcon);
    });

    /* fill object to 'name' country */
    const country = countries.filter(item => item.path === name)[0];

    /* center map */
    map.panTo(new L.LatLng(country.lat, country.lng), {animate: true});

    /* print object data to elements */
    document.querySelector('.country__name').textContent = country.name;

    /* goods */
    const amountItems = (items, amountId) => {
        return items.reduce((accumulator, item, index) => {
            accumulator += `<li class="country-good"><h4 class="country-good__title"><a href="${item.link}" target="_blank" rel="noopener" class="country-good__link"><span class="country-good__name">${item.name}</span><span class="country-good__price" data-index="${country.id}-${amountId}-${index + 1}" data-price="${item.price}${country.currency}" data-length="${item.price.toString().replace('.','').length + country.currencyLength}">${item.price}${country.currency}</span></a></h4><p class="country-good__desc">${item.desc}</p></li>`;
            return accumulator;
        }, '');
    };

    /* country */
    const countryContent = country.amounts.reduce((accumulator, item, index) => {
        accumulator += `<div class="country-item" data-id="${index + 1}"><h3 class="country-item__conversion">${amounts[index]}&nbsp;&#8381;&nbsp;= ${item.conversion}&nbsp;${country.currency}</h3><div class="country-item__pic"><img src="img/goods/${country.id}-${item.id}.jpg" alt=""></div><ul class="country-item__goods" data-size="${item.items.length}">${amountItems(item.items, item.id)}</ul></div>`;
        return accumulator;
    }, '');

    document.querySelector('.country__content').innerHTML = countryContent;

};

const showIndex = () => {

    setState('index');
    setCountry('');

    /* send data to analytics */
    analytics.pageview('/home');
    analytics.name('clientTracker').pageview('/home');

    /* reset markers on all countries */
    countriesMarkers.forEach((item) => {
        item.marker.setIcon(basicIcon);
    });

    /* reset background on all countries */
    countriesLayers.forEach((item) => {
        geojson.resetStyle(item.layer);
    });

    /* center map */
    map.panTo(new L.LatLng(countries[0].lat, countries[0].lng), {animate: true});

    /* click on 'continue' button */
    document.querySelector('.index__more').addEventListener('click', () => {
        router.navigate('/' + countries[0].path);
        analytics.event('Button', 'click', {eventLabel: 'More'});
    });
};

const Navigo = require('navigo');

const rootUrl = isProd ? data.meta.url : null;
const router = new Navigo(rootUrl, false, '#!');

router.on({
    '/:name': function (params) {
        showCountry(params.name);
    },
    '*': function () {
        showIndex();
    }
}).resolve();



/* analytics events */
[...document.querySelectorAll('.country__amount')].forEach((item) => {
    item.addEventListener('click', () => {
        analytics.event(document.querySelector('body').getAttribute('data-country'), 'click', {eventLabel: item.dataset.value});
        analytics.name('clientTracker').event(document.querySelector('body').getAttribute('data-country'), 'click', {eventLabel: item.dataset.value});
    });
});

document.querySelector('.country__content').addEventListener('click', (e) => {
    if (e.target.classList.contains('country-good__name') ||  e.target.classList.contains('country-good__price')) {
        analytics.event(document.querySelector('body').getAttribute('data-country'), 'click', {eventLabel: e.target.textContent});
        analytics.name('clientTracker').event(document.querySelector('body').getAttribute('data-country'), 'click', {eventLabel: e.target.textContent});
    }
});

[...document.querySelectorAll('.beeline__subhead a')].forEach((item) => {
    item.addEventListener('click', () => {
        analytics.event('Beeline', 'click', {eventLabel: item.textContent});
        analytics.name('clientTracker').event('Beeline', 'click', {eventLabel: item.textContent});
    });
});

document.querySelector('.header__gazeta').addEventListener('click', () => {
    analytics.event('Header', 'click', {eventLabel: 'Gazeta'});
    analytics.name('clientTracker').event('Header', 'click', {eventLabel: 'Gazeta'});
});

document.querySelector('.header__beeline').addEventListener('click', () => {
    analytics.event('Header', 'click', {eventLabel: 'Beeline'});
    analytics.name('clientTracker').event('Header', 'click', {eventLabel: 'Beeline'});
});



/* scroll depth */
window.$ = window.jQuery = require('jquery');
require('../node_modules/scroll-depth/jquery.scrolldepth.min.js');
jQuery(function() {
    jQuery.scrollDepth({
        eventHandler: function(data) {
            analytics.event(data.eventCategory, data.eventAction, {eventLabel: data.eventLabel});
            analytics.name('clientTracker').event(data.eventCategory, data.eventAction, {eventLabel: data.eventLabel});
        }
    });
});



/* service worker */
// if ('serviceWorker' in navigator) {
//     navigator.serviceWorker.register('./sw.js');
// }



/* likes */
require('../node_modules/ilyabirman-likely/release/likely.js');



// WEBPACK FOOTER //
// ./app.js